import React, {useContext, useEffect, useRef, useState} from "react"
import {
    Backdrop,
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import Draggable from "react-draggable";
import {Close as CloseIcon} from "@mui/icons-material";
import DetailView from "./detail"
import ContactView from "./contact"
import HistoryView from "./history"
import EditView from "./edit"
import {AppDataContext} from "../../../../App";
import UseApiManager from "../../../manager/api";

const styles = {
    root: {
        background: 'white',
        padding: '4px 16px',
        borderRadius: '8px',
        boxShadow: '1px 1px 3px #000',
        minWidth: "100px",
        minHeight: "120px",
        maxHeight: "90%",
    },
    titleBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#5c5ca2',
    },
    content: {
        minWidth: "800px",
        minHeight: "500px",
        width: "60%",
        height: "60%",
        maxHeight: "90%",
        maxWidth: "90%",
    },
    loading: {

    },
}

const PaperComponent = (props) => {
    return (
        <Draggable
            handel="tree-info-view-title"
            cancel={'[class*="MuiDialogContent-root"]'}
            >
            <Paper {...props} />
        </Draggable>
    )
}

const InfoViewMode = {
    Detail: "detail",
    History: "history",
    Contact: "contact",
    Edit: "edit",
}

const TreeInfoView = ({onClose}) => {

    const { state } = useContext(AppDataContext)
    const { GetFirst } = UseApiManager()
    const [infoViewMode, setInfoViewMode] = useState(InfoViewMode.Detail)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [data, setData] = useState()
    const rootRef = useRef()
    const [height, setHeight] = useState("100%")

    useEffect(() => {
        window.addEventListener("resize", () => {
            setHeight(`${window.innerHeight - 120}px`)
        })
        setHeight(`${window.innerHeight - 120}px`)
    }, [])

    useEffect(() => {
        setLoading(true)
        setError(null)
        setData(null)
        if (!state.treeInfoModel) { return }

        GetFirst(`tree/detail/${state.treeInfoModel.tree_uid}`)
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false))

    }, [state.treeInfoModel])

    if (!state.treeInfoModel) { return null }

    return (
        <Backdrop open={!!state.treeInfoModel}>
            <Box style={styles.root} ref={rootRef}>
                <Box style={styles.titleBox}>
                    <ToggleButtonGroup value={infoViewMode} size="small" disabled={!!loading}>
                        <ToggleButton value={InfoViewMode.Detail} onClick={() => setInfoViewMode(InfoViewMode.Detail)}>詳細</ToggleButton>
                        <ToggleButton value={InfoViewMode.History} onClick={() => setInfoViewMode(InfoViewMode.History)}>編集履歴</ToggleButton>
                        <ToggleButton value={InfoViewMode.Contact} onClick={() => setInfoViewMode(InfoViewMode.Contact)}>相談記録</ToggleButton>
                        <ToggleButton value={InfoViewMode.Edit} onClick={() => setInfoViewMode(InfoViewMode.Edit)}>データ編集</ToggleButton>
                    </ToggleButtonGroup>
                    <IconButton onClick={onClose}><CloseIcon /></IconButton>
                </Box>
                <Box style={styles.content}>
                    {!loading && data && infoViewMode === InfoViewMode.Detail && <DetailView data={data} columnDefs={state.columnDefs} height={height} />}
                    {!loading && data && infoViewMode === InfoViewMode.History && <HistoryView data={data} columnDefs={state.columnDefs} />}
                    {!loading && data && infoViewMode === InfoViewMode.Contact && <ContactView data={data} columnDefs={state.columnDefs} />}
                    {!loading && data && infoViewMode === InfoViewMode.Edit && <EditView data={data} columnDefs={state.columnDefs} />}
                    {error && (
                        <Box style={styles.error}>
                            読み込みエラー
                        </Box>
                    )}
                    {loading && (
                        <Box style={styles.loading}>
                            読込中...
                        </Box>
                    )}
                </Box>
            </Box>
        </Backdrop>
    )
}

TreeInfoView.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default TreeInfoView

export const TreeInfoContentViewProps = {
    data: PropTypes.object,
    columnDefs: PropTypes.object,
}
